import { useQuery } from '@tanstack/react-query'

import { repositoriesApi } from '@/lib/api'
import { queryKeys } from '@/lib/queryClient'

export function useRepositories(includeArchived = false) {
  return useQuery({
    queryKey: queryKeys.repositories(includeArchived),
    queryFn: () => repositoriesApi.list({ includeArchived }),
    staleTime: 60_000, // Repository metadata changes slowly; GitHub's search quota does not.
  })
}

export function useRepository(owner: string, repo: string) {
  return useQuery({
    queryKey: queryKeys.repository(owner, repo),
    queryFn: () => repositoriesApi.detail(owner, repo),
    enabled: Boolean(owner && repo),
  })
}

export function useRepositoryIssues(owner: string, repo: string, state: 'open' | 'closed' | 'all') {
  return useQuery({
    queryKey: queryKeys.repositoryIssues(owner, repo, state),
    queryFn: () => repositoriesApi.issues(owner, repo, { state }),
    enabled: Boolean(owner && repo),
  })
}

export function useRepositoryLabels(owner: string, repo: string) {
  return useQuery({
    queryKey: queryKeys.repositoryLabels(owner, repo),
    queryFn: () => repositoriesApi.labels(owner, repo),
    enabled: Boolean(owner && repo),
  })
}
